<template>
    <home endpoint="station" :params="params"></home>
</template>

<script>
import home from '@/components/tools/Index'
export default {
  name: 'station',
  components: {
    home,
  },
  data () {
    return {
      params: {
        fields: [
          {name: 'id', label: 'Código', required: true},
          {name: 'Name', label: 'Nombre', required: true},
          {name: 'CityName', label: 'Ciudad', required: true},
          {name: 'CountryCode', label: 'Código de país', required: true},
          {name: 'Closed', label: 'Cerrado', editor: 'checkbox'}],
        title: 'Station',
        title2: 'Station'
      }
    }
  },
}
</script>

